(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["slideshow-slide"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__slideshowFancyboxInit) return;
  window.__slideshowFancyboxInit = true;

  function loadFancybox(cb) {
    if (window.Fancybox) { cb(); return; }
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@6.0/dist/fancybox/fancybox.css';
    document.head.appendChild(link);

    var script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/@fancyapps/ui@6.0/dist/fancybox/fancybox.umd.js';
    script.async = true;
    script.onload = cb;
    document.head.appendChild(script);
  }

  function getHighResSrc(img) {
    return img?.dataset.zoomSrc || img?.dataset.maxResolution || img.src;
  }

  function bindFancybox() {
    // Only target product gallery slides
    document.querySelectorAll('.product__media slideshow-slides, .media-gallery--carousel slideshow-slides').forEach(function(wrapper) {
      var allSlides = Array.from(wrapper.querySelectorAll('slideshow-slide')).filter(slide => slide.querySelector('img'));
      if (!allSlides.length) return;

      // Only original slides
      var originalSlides = allSlides.filter(slide => !slide.classList.contains('swiper-slide-duplicate'));
      var gallery = originalSlides.map(slide => {
        var img = slide.querySelector('img');
        return { src: getHighResSrc(img), type: 'image', caption: img.alt || '' };
      });

      // Preload images
      gallery.forEach(item => { new Image().src = item.src; });

      allSlides.forEach(slide => {
        var img = slide.querySelector('img');
        if (!img || img.dataset.fancyboxBound) return;
        img.dataset.fancyboxBound = 'true';
        img.style.cursor = 'zoom-in';

        img.addEventListener('click', function(ev) {
          ev.preventDefault();
          ev.stopPropagation();

          var idxAttr = slide.dataset.swiperSlideIndex;
          var startIndex = parseInt(idxAttr ?? 0, 10);
          if (isNaN(startIndex) || startIndex < 0 || startIndex >= gallery.length) startIndex = 0;

          if (window.Fancybox?.show) {
            setTimeout(() => {
              document.querySelectorAll('.f-panzoom__content').forEach(el => el.style.visibility = 'visible');
            }, 50);

            window.Fancybox.show(gallery, {
              startIndex: startIndex,
              Thumbs: false,
              Toolbar: { display: ['zoom', 'close'] },
              dragToClose: false,
              showClass: false,
              hideClass: false,
              on: {
                destroy: () => {
                  document.querySelectorAll('.f-panzoom__content').forEach(el => el.style.visibility = '');
                }
              }
            });
          } else {
            var url = gallery[startIndex]?.src;
            if (url) window.open(url, '_blank');
          }
        });
      });
    });
  }

  loadFancybox(function() {
    bindFancybox();
    setTimeout(bindFancybox, 300); // Slight delay for Swiper clones
    try {
      new MutationObserver(() => bindFancybox())
        .observe(document.querySelector('.product__media') || document, { childList: true, subtree: true });
    } catch(e){}
  });
})();
  } catch(e) { console.error(e); }
})();

})();
